import { Action } from '@ngrx/store';
import { IContextDevice } from '@store/context/context.state';

export enum Type {
  SET_DEVICE_INIT = '[App] Set Device Init',
  SET_DEVICE_SUCCESS = '[App] Set Device Success',
  SET_LANDING_VIEW_OFF = '[App] Set Landing View Off',
}

export class SetDeviceInit implements Action {
  public readonly type = Type.SET_DEVICE_INIT;
  constructor() {}
}

export class SetDeviceSuccess implements Action {
  public readonly type = Type.SET_DEVICE_SUCCESS;
  constructor(public payload: IContextDevice) {}
}

export class TurnLandingViewOff implements Action {
  public readonly type = Type.SET_LANDING_VIEW_OFF;
  constructor() {}
}

export type Actions = SetDeviceInit | SetDeviceSuccess | TurnLandingViewOff;
